import { DatePipe } from "@angular/common";
import { AfterViewInit, ChangeDetectorRef, Component, OnInit, ViewChild } from "@angular/core";
import { FormBuilder } from "@angular/forms";
import { Router, ActivatedRoute } from "@angular/router";
import { NgbModal, NgbModalRef } from "@ng-bootstrap/ng-bootstrap";
import { SwalComponent } from "@sweetalert2/ngx-sweetalert2";
import * as moment from "moment";
import { Emisor } from "src/app/models/Emisor/Emisor";
import { EmisorFilter } from "src/app/models/Emisor/EmisorFilter";
import { EmisorService } from "src/app/services/emisor.service";
import { LocalStorageService } from "src/app/services/local-storage.service";
import { PersonasAutorizadasService } from "src/app/services/paseronas-autorizadas.service";
import { PermissionService } from "src/app/services/permission.service";
import { TokenStorageService } from "src/app/services/token-storage.service";
import { UtilitiesService } from "src/app/services/utilities.service";
import { Page } from "src/app/shared/models/Page";
import { PagedResponse } from "src/app/shared/models/PagedResponse";
import { DatatableComponent, SortType } from "@swimlane/ngx-datatable";
import { ResellerService } from "src/app/services/reseller.service";
import { Reseller } from "src/app/models/Reseller/Reseller";
import { ResumenReseller } from "src/app/models/Reseller/ResumenReseller";
import { PlanUsuarioService } from "src/app/services/planUsuario.service";
import { PlanFacturacion } from "src/app/models/PlanesUsuario/PlanFacturacion";
import Swal from "sweetalert2";
import { CertificacionPrecio } from "src/app/models/PlanesUsuario/CertificacionPrecio";
import { Resumen } from "src/app/models/PlanesUsuario/Resumen";
import { SessionUser } from "src/app/shared/models/sessionUser";
import { Plan } from "src/app/models/PlanesUsuario/Plan";
import { UsuarioService } from "src/app/services/usuario.service";
import { PlanUsuario } from "src/app/models/PlanesUsuario/PlanUsuario";
import { CambioPlanPartner } from "src/app/models/PlanesUsuario/CambioPlanPartner";
import { PerfectScrollbarConfigInterface } from "ngx-perfect-scrollbar";
import { CertificacionCliente } from "src/app/models/PlanesUsuario/CertificacionCliente";
import { CertificacionInstructivo } from "src/app/models/PlanesUsuario/CertificacionInstructivo";

@Component({
	selector: "app-partner-panel",
	templateUrl: "./partner-panel.component.html",
	styleUrls: ["./partner-panel.component.scss"],
})
export class PartnerPanelComponent implements OnInit {
	@ViewChild("tablaPlanes") tablaPlanes: DatatableComponent;
	@ViewChild("tablaFacturas") tablaFacturas: DatatableComponent;

	@ViewChild("tableMobile") tableRef: any;

	SortType = SortType;
	public loading = false;
	public pageFacturas = new Page();
	public pagePlanes = new Page();
	public rowsPlanesMantenedor: Emisor[] = [];
	public rowsFacturasMantenedor: PlanFacturacion[] = [];
	public configScroll: PerfectScrollbarConfigInterface = {};
	public resumenReseller: ResumenReseller;
	public componentStarted: boolean = false;
	public mes: number;
	public anio: number;
	public periodo: String;
	public ultimaFactura: PlanFacturacion;
	public currentModalRef: NgbModalRef;
	activeTabId: "planes" | "facturas" | "certificaciones";

	public empresaCertSeleccionada: Emisor = null;
	public certificacionesTab: CertificacionCliente[] = [];
	public certificacionesTabLoaded = false;
	public certificacionesDisponibles: CertificacionPrecio[] = [];
	public certificacionesDisponiblesLoaded = false;
	public solicitandoCertificaciones = false;
	private readonly certificacionEstadoDesactivadaId = 6;

	public planSeleccionado: Plan;
	public planOriginal: Plan = null;
	public planes: Plan[];

	periodos: any[] = [];
	public reseller: Reseller;

	public resumenCuenta: Resumen;
	public user: SessionUser;
	public planActual: PlanUsuario;

	private currentEmisorId: string;
	public currentEmisor: Emisor;
	public nombreProximoMes: string;

	public planAhora: boolean;

	@ViewChild("currentSwal") private currentSwal: SwalComponent;

	constructor(public utilities: UtilitiesService, private tokenService: TokenStorageService, private userService: UsuarioService, private modalService: NgbModal, private planService: PlanUsuarioService, private resellerService: ResellerService, public router: Router, public permissions: PermissionService, private ref: ChangeDetectorRef, private localStorage: LocalStorageService) {
		this.reseller = this.tokenService.getReseller();
		this.pageFacturas.pageSize = 5;
		this.user = this.tokenService.getUser() as SessionUser;
		this.currentEmisorId = this.tokenService.getCompany();
		this.planAhora = true;
	}

	ngOnInit(): void {
		this.generatePeriodsFromDate(new Date(this.reseller.fechaCreacion));
		this.periodo = this.periodos[this.periodos.length - 1].label;
		this.mes = this.periodos[this.periodos.length - 1].month;
		this.anio = this.periodos[this.periodos.length - 1].year;
		this.setPagePlanes({ offset: 0 }); //Obtiene info de planes
		this.setPageFacturas({ offset: 0 }); //Obtiene las facturas
		//this.setActiveTabId("planes");
		this.obtenerResumenReseller(); //Obtiene resumen
	}
	ngAfterViewInit() {
		this.setActiveTabId("planes");
	  }
	onTabShown() {}

	toggleExpandRow(row) {
		if (!this.tableRef) { return; }
		this.tableRef.rowDetail.toggleExpandRow(row);
	  }
	  
	public getTotalPages(rowCount: number, pageSize: number): number {
		if (!pageSize) { 
		  return 1; 
		}
		return Math.ceil(rowCount / pageSize);
	  }
	  

	cancelarPlan(idPlan) {
		return Swal.fire({
			icon: "warning",
			title: "¿Está seguro de dar de baja este plan?",
			confirmButtonText: "Dar de baja",
			showConfirmButton: true,
			denyButtonText: "Cancelar",
			showDenyButton: true,
		}).then((result) => {
			if (result.isDenied) {
			} else if (result.isConfirmed) {
				this.planService.cancelarPlan(idPlan).subscribe((data) => {
					this.currentSwal.icon = "success";
					this.currentSwal.title = "Plan cancelado";
					this.currentSwal.text = "El plan ha sido cancelado exitosamente. El equipo comercial se pondrá en contacto con usted.";
					this.currentSwal.fire();
					this.setPagePlanes({ offset: 0 });
					this.obtenerResumenReseller();
				});
			}
		});
	}

	// actualizarCert(certificaciones) {
	// 	this.certificaciones = certificaciones;
	// }

	actualizarResumen(resumen) {
		this.resumenCuenta = resumen;
		if (this.user.configured) this.resumenCuenta.idContratacion = null;
	}

	cambiarPlan(modalRef, empresa: Emisor) {
		let fechaActual = new Date();
		this.nombreProximoMes = this.getNextMonthName(fechaActual.getMonth() + 1, fechaActual.getFullYear());
		this.loading = true;
		this.planSeleccionado = null;
		this.planOriginal = null;
		this.planActual = new PlanUsuario();
		let emisoresList = JSON.parse(this.localStorage.getEmisores()) as Emisor[];
		this.currentEmisor = emisoresList.find((e) => e.emisorId == empresa.emisorId);
		this.currentEmisorId = empresa.emisorId;
		const idPlanUsuarioEmpresa = empresa.planUsuarioId;
		//Trae el listado de certificaciones con sus precios y los planes existentes
		this.planService.getInitialData().subscribe((data) => {
			//this.planes = data.planes;
			//this.planes = data.planes.filter(plan => plan.antiguedad === 'Nuevo');
			//this.certificaciones = data.certificaciones;
			this.userService.getUser(this.user.id, empresa.emisorId).subscribe((response) => {
				const planReal = response.data.planesUsuario.find((y) => y.idPlanUsuario === idPlanUsuarioEmpresa);
				this.planActual = planReal;
				const fechaCorte = moment(this.planActual.fechaCorte);
				const fechaActual = moment();
				const planesNuevos = data.planes.filter((plan) => plan.id === this.planActual.idPlanSf && plan.antiguedad === 'Nuevo');
				if (fechaActual.isSameOrAfter(fechaCorte) || planesNuevos.length > 0) {
					this.planes = data.planes.filter((plan) => plan.antiguedad === 'Nuevo');
				} 
				else {
				const planesFiltrados = data.planes.filter((plan) => plan.antiguedad === 'Nuevo' && plan.nombre !== this.planActual.nombrePlan);
				const indiceOriginal = data.planes.findIndex((plan) => plan.nombre === this.planActual.nombrePlan);
				let posicionInsercion = 0;
				for (const plan of planesFiltrados) {
					const indicePlan = data.planes.findIndex((p) => p.nombre === plan.nombre);
					if (indicePlan < indiceOriginal) {
						posicionInsercion++;
					}
				}
				this.planes = [...planesFiltrados];
				const planCorrespondiente = data.planes.find((p) => p.nombre === this.planActual.nombrePlan);
				if (planCorrespondiente) {
					planCorrespondiente.id = this.planActual.idPlanUsuario;
					this.planes.splice(posicionInsercion, 0, planCorrespondiente);
				}
				}
		  
				this.handleUserData(response.data, "change");
			}, this.handleError);

			this.loading = false;
			this.ref.detectChanges();
		});

		this.currentModalRef = this.modalService.open(modalRef, {
			windowClass: "",
			size: "xl",
		});
	}

	updatePlanAhora(event: Event) {
		this.planAhora = (event.target as HTMLInputElement).checked;
	}

	procederCambioPlan() {
		return Swal.fire({
			icon: "warning",
			title: "¿Está seguro de cambiar este plan?",
			confirmButtonText: "Nuevo plan",
			text: "Se procederá a cambiar el plan actual por el seleccionado. Esta acción puede ser reversible contactando con soporte.",
			showConfirmButton: true,
			denyButtonText: "Cancelar",
			showDenyButton: true,
		}).then((result) => {
			if (result.isDenied) {
			} else if (result.isConfirmed) {
				let model = new CambioPlanPartner();
				model.idEmisor = this.currentEmisorId;
				model.idUsuario = this.user.id;
				model.idPlanUsuario = this.planActual.idPlanUsuario;
				model.idPlanSf = this.planSeleccionado.id;
				model.changeNow = this.planAhora;
				this.currentModalRef.close();
				this.planService.cambiarPlanPartner(model).subscribe((data) => {
					this.currentSwal.icon = "success";
					this.currentSwal.title = "Nuevo Plan";
					this.currentSwal.text = "Se ha realizado el cambio exitosamente. El equipo comercial se pondrá en contacto con usted.";
					this.currentSwal.fire();
					this.setPagePlanes({ offset: 0 });
					this.obtenerResumenReseller();
				});
			}
		});
	}

	handleUserData(userData: any, type: string): void {
		let planActual: PlanUsuario;
		if (this.planActual.idPlanUsuario != null && this.planActual.idPlanUsuario != undefined) {
			//Existe un plan
			planActual = userData.planesUsuario.find((y) => y.idPlanUsuario === this.planActual.idPlanUsuario);
			this.handlePlanActual(userData, planActual);
		} else {
			//Es posible que el IdUsuario esté dentro de los planes del usuario
			planActual = userData.planesUsuario[0];
			this.handlePlanActual(userData, planActual);
		}
	}

	handlePlanActual(userData: any, planActual: PlanUsuario): void {
		this.planSeleccionado = this.planes.find((x) => x.nombre === planActual.nombrePlan);
		if (!this.planOriginal) this.planOriginal = this.planSeleccionado;
	}

	handleError(error): void {
		Swal.fire({
			title: "Error en datos",
			text: "No fue posible obtener los datos del usuario actual, favor intente nuevamente",
			icon: "error",
		});
	}

	updatePlan(plan: Plan) {
		this.planSeleccionado = plan;
	}

	closeModal() {
		this.currentModalRef.close();
	}

	obtenerPDF() {
		this.planService.getFacturaPDF(this.ultimaFactura.facturaId).subscribe((data) => {
			let pdfBlob = this.utilities.convertB64ToBlob(data.data, "application/pdf");
			let pdfUrl = URL.createObjectURL(pdfBlob);
			this.popupCenter(pdfUrl, "Muestra de Documento", 600, 800);
		});
	}

	openPDF(idFactura) {
		this.planService.getFacturaPDF(idFactura).subscribe((data) => {
			let pdfBlob = this.utilities.convertB64ToBlob(data.data, "application/pdf");
			let pdfUrl = URL.createObjectURL(pdfBlob);
			this.popupCenter(pdfUrl, "Muestra de Documento", 600, 800);
		});
	}

	popupCenter(url, title, w, h) {
		const dualScreenLeft = window.screenLeft !== undefined ? window.screenLeft : window.screenX;
		const dualScreenTop = window.screenTop !== undefined ? window.screenTop : window.screenY;

		const width = window.innerWidth ? window.innerWidth : document.documentElement.clientWidth ? document.documentElement.clientWidth : screen.width;
		const height = window.innerHeight ? window.innerHeight : document.documentElement.clientHeight ? document.documentElement.clientHeight : screen.height;

		const systemZoom = width / window.screen.availWidth;
		const left = (width - w) / 2 / systemZoom + dualScreenLeft;
		const top = (height - h) / 2 / systemZoom + dualScreenTop;

		const newWindow = window.open(
			url,
			title,
			`
    scrollbars=yes,
    width=${w / systemZoom}, 
    height=${h / systemZoom}, 
    top=${top}, 
    left=${left}
    `
		);
		if (window.focus) {
			newWindow.focus();
		}
	}

	obtenerResumenReseller() {
		this.resellerService.getResumenReseller(this.reseller.resellerId).subscribe(
			(data) => {
				this.resumenReseller = data;
				this.ref.detectChanges();
			},
			(error) => {
				this.currentSwal.icon = "error";
				this.currentSwal.title = "Error al obtener Resumen de Partner. Contactar con Administrador";
				this.currentSwal.text = error.error.message;
				this.currentSwal.fire();
			},
			() => {
				this.ref.detectChanges();
			}
		);
	}
	generatePeriodsFromDate(inputDate: Date) {
		let startDate = new Date(inputDate.getFullYear(), inputDate.getMonth(), 1); // Esta es una copia de la fecha con tiempo omitido
		let currentDate = new Date();
		currentDate = new Date(currentDate.getFullYear(), currentDate.getMonth(), 1); // Omitir tiempo de la fecha actual también

		while (startDate <= currentDate) {
			this.periodos.push({
				label: `${this.getMonthName(startDate.getMonth())} - ${startDate.getFullYear()}`,
				month: startDate.getMonth() + 1, // porque getMonth() es 0-indexed
				year: startDate.getFullYear(),
			});
			startDate.setMonth(startDate.getMonth() + 1);
		}
	}
	getMonthName(monthIndex: number): string {
		const monthNames = ["Enero", "Febrero", "Marzo", "Abril", "Mayo", "Junio", "Julio", "Agosto", "Septiembre", "Octubre", "Noviembre", "Diciembre"];
		return monthNames[monthIndex];
	}

	getNextMonthName(monthIndex: number, year: number): string {
		const monthNames = ["Enero", "Febrero", "Marzo", "Abril", "Mayo", "Junio", "Julio", "Agosto", "Septiembre", "Octubre", "Noviembre", "Diciembre"];
		//Retornar el mes siguiente al monthIndex y year
		if (monthIndex == 12) {
			return monthNames[0] + " - " + (year + 1);
		} else {
			return monthNames[monthIndex + 1] + " - " + year;
		}
	}

	onPeriodChange(selectedPeriod: any) {
		const period = this.periodos.find((p) => p.label === selectedPeriod.label);
		if (period) {
			this.mes = period.month;
			this.anio = period.year;
			this.setPagePlanes({ offset: 0 });
		}
	}

	setPageFacturas(pageInfo) {
		this.pageFacturas.pageNumber = pageInfo.offset;
		let localPage = JSON.parse(JSON.stringify(this.pageFacturas));
		localPage.pageNumber += 1;
		this.resellerService
			.getFacturasByResellerByPage(localPage, this.reseller.resellerId)
			.subscribe(
				(pagedData) => {
					let elements = pagedData.data as PlanFacturacion[];
					this.ref.detectChanges();
					this.rowsFacturasMantenedor = [...elements];
					this.ultimaFactura = elements[0];
					// elements.forEach((row, i) => {
					// 	this.rowsMantenedor[i].ambiente = this.rowsMantenedor[i].ambienteEnt.ambienteId;
					// 	this.rowsMantenedor[i].nombreAmbiente = this.rowsMantenedor[i].ambienteEnt.nombre;
					// });
					this.setPageFacturasfromResponse(this.pageFacturas, pagedData);
					this.ref.detectChanges();
				},
				(error) => {
					this.currentSwal.icon = "error";
					this.currentSwal.title = "Error en la solicitud";
					this.currentSwal.text = error.error.message;
					this.currentSwal.fire();
				},
				() => {
					this.ref.detectChanges();
				}
			)
			.add(() => {
				this.componentStarted = true;
				this.ref.detectChanges();
			});
	}

	setPagePlanes(pageInfo) {
		this.loading = true;
		this.pagePlanes.pageNumber = pageInfo.offset;
		let localPage = JSON.parse(JSON.stringify(this.pagePlanes));
		localPage.pageNumber += 1;
		this.resellerService
			.getPlanesByResellerByPage(localPage, this.reseller.resellerId, this.anio, this.mes, this.periodo)
			.subscribe(
				(pagedData) => {
					let elements = pagedData.data as Emisor[];
					this.ref.detectChanges();
					this.rowsPlanesMantenedor = [...elements];
					this.empresaCertSeleccionada =
					this.rowsPlanesMantenedor.length > 0
						? this.rowsPlanesMantenedor[0]
						: null;

					// Carga las certificaciones de la empresa seleccionada.
					this.onEmpresaCertificacionChange();
					// elements.forEach((row, i) => {
					// 	this.rowsMantenedor[i].ambiente = this.rowsMantenedor[i].ambienteEnt.ambienteId;
					// 	this.rowsMantenedor[i].nombreAmbiente = this.rowsMantenedor[i].ambienteEnt.nombre;
					// });
					this.setPagePlanesfromResponse(this.pagePlanes, pagedData);
					this.loading = false;
					this.ref.detectChanges();
				},
				(error) => {
					this.loading = false;
					this.currentSwal.icon = "error";
					this.currentSwal.title = "Error en la solicitud";
					this.currentSwal.text = error.error.message;
					this.currentSwal.fire();
				},
				() => {
					this.loading = false;
					this.ref.detectChanges();
				}
			)
			.add(() => {
				this.loading = false;
				this.componentStarted = true;
				this.ref.detectChanges();
			});
	}

	setPagePlanesfromResponse(currentPage: Page, data: PagedResponse<Emisor>) {
		currentPage.pageSize = data.pageSize;
		currentPage.pageNumber = data.pageNumber - 1 < 0 ? 0 : data.pageNumber - 1;
		currentPage.totalPages = data.totalPages;
		currentPage.totalElements = data.totalRecords;
	}

	setPageFacturasfromResponse(currentPage: Page, data: PagedResponse<PlanFacturacion>) {
		currentPage.pageSize = data.pageSize;
		currentPage.pageNumber = data.pageNumber - 1 < 0 ? 0 : data.pageNumber - 1;
		currentPage.totalPages = data.totalPages;
		currentPage.totalElements = data.totalRecords;
	}

	setPageSizePlanes() {
		//this.page.currentPageSize = this.page.page
		this.setPagePlanes({ offset: 0 });
	}

	setPageSizeFacturas() {
		//this.page.currentPageSize = this.page.page
		this.setPageFacturas({ offset: 0 });
	}

	onColumnResizeFacturas(resizeEvent) {
		this.tablaFacturas.recalculateDims();
		// this.tablaPlanes.recalculateDims();
		//window.dispatchEvent(new Event("resize"));
	}

	onColumnResizePlanes(resizeEvent) {
		// this.tablaFacturas.recalculateDims();
		this.tablaPlanes.recalculateDims();
		// window.dispatchEvent(new Event("resize"));
	}

	setActiveTabId(tabId) {
		this.activeTabId = tabId;

		this.tablaFacturas.recalculate();
		this.tablaPlanes.recalculate();
		this.ref.detectChanges();
		window.dispatchEvent(new Event("resize"));
	}

	getActiveCSSClasses(tabId) {
		if (tabId !== this.activeTabId) {
			return "";
		}
		return "active show";
	}
	onLogoSelected(evt: Event) {
		const input = evt.target as HTMLInputElement;
		if (!input.files || input.files.length === 0) return;

		const file = input.files[0];
		const reader = new FileReader();
		reader.onload = () => {
			const dataUrl = reader.result as string;
			const base64 = dataUrl.split(',')[1];
			if (base64) {
			this.reseller.logoFile = base64;
			this.ref.detectChanges();
			}
		};
		reader.readAsDataURL(file);

		this.loading = true;
		this.resellerService.uploadLogo(this.reseller.resellerId, file).subscribe({
			next: (resp) => {
				//actualizar logo en localstorage
				if (resp.data) {
					this.reseller.logoFile = resp.data;
					this.tokenService.saveResellerData(true,this.reseller);
				}
				this.loading = false;
				this.ref.detectChanges();
				this.currentSwal.icon = "success";
				this.currentSwal.title = "Logo actualizado";
				this.currentSwal.text = "El logo del partner se actualizó correctamente.";
				this.currentSwal.fire();
			},
			error: (err) => {
				this.loading = false;
				this.ref.detectChanges();
				this.currentSwal.icon = "error";
				this.currentSwal.title = "No se pudo actualizar el logo";
				this.currentSwal.text = err?.error?.message ?? "Intente nuevamente.";
				this.currentSwal.fire();
			}
		});
	}

	onEmpresaCertificacionChange(): void {
		this.certificacionesTab = [];
		this.certificacionesTabLoaded = false;
		this.certificacionesDisponibles = [];
		this.certificacionesDisponiblesLoaded = false;
		if (!this.empresaCertSeleccionada) return;
		this.loadCertificacionesTab();
		this.loadCertificacionesDisponibles();
	}

	private loadCertificacionesTab(): void {
		if (!this.empresaCertSeleccionada?.planUsuarioId) {
			this.certificacionesTab = [];
			this.certificacionesTabLoaded = true;
			return;
		}
		this.planService.getCertificacionesCliente(this.empresaCertSeleccionada.planUsuarioId).subscribe({
			next: (data) => {
				const certsNormalizadas = ((data as any) || []).map((c: any) => ({
					certificacionId: c?.certificacionId ?? c?.CertificacionId ?? "",
					codigoSii: c?.codigoSii ?? c?.CodigoSii,
					nombreCertificacion: c?.nombreCertificacion ?? c?.NombreCertificacion ?? "",
					estadoId: c?.estadoId ?? c?.EstadoId,
					estadoNombre: c?.estadoNombre ?? c?.EstadoNombre ?? "",
					fechaSolicitud: c?.fechaSolicitud ?? c?.FechaSolicitud ?? null,
					fechaFinalizacion: c?.fechaFinalizacion ?? c?.FechaFinalizacion ?? null,
					fechaConfirmada: c?.fechaConfirmada ?? c?.FechaConfirmada ?? null,
					pagado: c?.pagado ?? c?.Pagado ?? false,
				})) as CertificacionCliente[];
				this.certificacionesTab = certsNormalizadas.filter((c) => {
					const estadoNombre = (c.estadoNombre || "").trim().toLowerCase();
					return Number(c.estadoId) !== this.certificacionEstadoDesactivadaId && estadoNombre !== "desactivada";
				});
				this.certificacionesTabLoaded = true;
				this.ref.detectChanges();
			},
			error: () => {
				this.certificacionesTab = [];
				this.certificacionesTabLoaded = true;
				this.ref.detectChanges();
			},
		});
	}

	private loadCertificacionesDisponibles(): void {
		if (!this.empresaCertSeleccionada?.emisorId) {
			this.certificacionesDisponibles = [];
			this.certificacionesDisponiblesLoaded = true;
			return;
		}
		this.planService.getCertificacionesCompra(this.empresaCertSeleccionada.emisorId).subscribe({
			next: (resp) => {
				let certs: CertificacionPrecio[] = [];
				if (Array.isArray(resp)) {
					certs = resp;
				} else if (resp && Array.isArray((resp as any).certificaciones)) {
					certs = (resp as any).certificaciones;
				}
				certs.forEach((c) => (c.solicitada = false));
				this.certificacionesDisponibles = certs;
				this.certificacionesDisponiblesLoaded = true;
				this.ref.detectChanges();
			},
			error: () => {
				this.certificacionesDisponibles = [];
				this.certificacionesDisponiblesLoaded = true;
				this.ref.detectChanges();
			},
		});
	}

	get hayCertificacionesParaSolicitar(): boolean {
		return this.certificacionesDisponibles?.some((c) => c.solicitada && !c.disabled) ?? false;
	}

	get totalCertificacionesSeleccionadas(): number {
		return (this.certificacionesDisponibles || [])
			.filter((c) => c.solicitada && !c.disabled)
			.reduce((total, c) => total + (c.valor || 0), 0);
	}

	toggleCertificacionDisponible(cert: CertificacionPrecio): void {
		if (cert.disabled || this.solicitandoCertificaciones) return;
		cert.solicitada = !cert.solicitada;
	}

	solicitarCertificacionesSeleccionadas(): void {
		const seleccionadas = (this.certificacionesDisponibles || []).filter((c) => c.solicitada && !c.disabled);
		if (!seleccionadas.length || !this.empresaCertSeleccionada) return;

		this.solicitandoCertificaciones = true;
		const solicitudes = seleccionadas.map((cert) =>
			this.resellerService.solicitarCertificacion(this.reseller.resellerId, this.empresaCertSeleccionada.emisorId, cert.codigoPrincipal)
		);

		let pendientes = solicitudes.length;
		let fallidas = 0;
		solicitudes.forEach((solicitud$) => {
			solicitud$.subscribe({
				next: () => {
					pendientes--;
					if (pendientes === 0) this.finalizarSolicitudCertificaciones(fallidas);
				},
				error: () => {
					fallidas++;
					pendientes--;
					if (pendientes === 0) this.finalizarSolicitudCertificaciones(fallidas);
				},
			});
		});
	}

	private finalizarSolicitudCertificaciones(fallidas: number): void {
		this.solicitandoCertificaciones = false;
		if (fallidas === 0) {
			this.currentSwal.icon = "success";
			this.currentSwal.title = "Certificaciones solicitadas";
			this.currentSwal.text = "Se incluirán en tu próxima liquidación mensual.";
			this.currentSwal.fire();
		} else {
			this.currentSwal.icon = "warning";
			this.currentSwal.title = "Solicitud parcial";
			this.currentSwal.text = `${fallidas} certificación(es) no se pudieron solicitar. Intenta nuevamente.`;
			this.currentSwal.fire();
		}
		this.loadCertificacionesTab();
		this.loadCertificacionesDisponibles();
		this.ref.detectChanges();
	}

	getCertEstadoClass(estadoId: number): string {
		switch (Number(estadoId)) {
			case 1:
			case 4:
				return "badge-light-success";
			case 2:
				return "badge-light-primary";
			case 3:
				return "badge-light-danger";
			case 5:
				return "badge-light-info";
			case 6:
				return "badge-light-secondary";
			default:
				return "badge-light-warning";
		}
	}

	puedeGestionarInstructivo(cert: CertificacionCliente): boolean {
		const estado = Number(cert?.estadoId ?? 0);
		return estado === 4 || estado === 5;
	}

	descargarInstructivo(cert: CertificacionCliente): void {
		if (!this.empresaCertSeleccionada?.planUsuarioId || !cert?.certificacionId) return;

		this.planService.getInstructivoCertificacion(this.empresaCertSeleccionada.planUsuarioId, cert.certificacionId).subscribe({
			next: (resp) => {
				const data = resp?.data as CertificacionInstructivo;
				if (!data?.instructivoUrl) {
					Swal.fire("No disponible", "No fue posible resolver el instructivo para esta certificación.", "warning");
					return;
				}
				window.open(data.instructivoUrl, "_blank", "noopener,noreferrer");
			},
			error: (error) => {
				Swal.fire("Error", "No fue posible abrir el instructivo." + this.utilities.setErrorMessageFromArray(error?.error), "error");
			},
		});
	}

	reenviarInstructivo(cert: CertificacionCliente): void {
		if (!this.empresaCertSeleccionada?.planUsuarioId || !cert?.certificacionId) return;

		Swal.fire({
			title: "Reenviar instructivo",
			text: "Ingresa el correo de destino. Si lo dejas vacío, se usará el correo asociado al proceso.",
			input: "email",
			inputValue: this.user?.email ?? "",
			showCancelButton: true,
			confirmButtonText: "Reenviar",
			cancelButtonText: "Cancelar",
			inputValidator: (value) => {
				if (!value) return null;
				const ok = /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value);
				return ok ? null : "Debes ingresar un correo válido.";
			},
		}).then((result) => {
			if (!result.isConfirmed) return;

			this.planService.reenviarInstructivoCertificacion({
				idPlanUsuario: this.empresaCertSeleccionada.planUsuarioId,
				certificacionId: cert.certificacionId,
				correoDestino: result.value || undefined,
			}).subscribe({
				next: () => {
					Swal.fire("Listo", "El instructivo fue reenviado correctamente.", "success");
				},
				error: (error) => {
					Swal.fire("Error", "No fue posible reenviar el instructivo." + this.utilities.setErrorMessageFromArray(error?.error), "error");
				},
			});
		});
	}
}
